import { render, staticRenderFns } from "./index.vue?vue&type=template&id=50aa4996&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=50aa4996&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../environment/web_node_modules/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aa4996",
  null
  
)

export default component.exports